import { render, staticRenderFns } from "./ImportFileModal.vue?vue&type=template&id=398b808e&scoped=true"
import script from "./ImportFileModal.vue?vue&type=script&lang=js"
export * from "./ImportFileModal.vue?vue&type=script&lang=js"
import style0 from "./ImportFileModal.vue?vue&type=style&index=0&id=398b808e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b808e",
  null
  
)

export default component.exports